var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100"},[(!_vm.isFile())?_c('div',{staticClass:"vue-pdf-previewer",attrs:{"id":_vm.localID}}):_c('embed',{staticClass:"w-100 h-100",attrs:{"id":"embeded-pdf","src":_vm.file}})])
}
var staticRenderFns = []

export { render, staticRenderFns }